import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(userDetailsListener),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(userDetailsSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(userDetailsSuccessSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(userAccountsListener),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(userAccountsSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(syncActiveAccountSaga),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(usersListener),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(usersSaga);

import { call, race, put, takeLatest, take, select } from 'redux-saga/effects';
import get from 'lodash/get';
import { push } from 'connected-react-router';
import createRequestSaga from '@signal/utils/createRequestSaga';
import { AuthError } from '@signal/utils/errors';
import { setUserContext } from '@signal/utils/errorReporting';
import { setFullStoryIdentity } from '@signal/utils/fullStory';
import api from '../api';
import { logout, setActiveAccount, activeAccountIdSelector } from '../auth';
import { accountsPathSelector } from '../router/selectors';
import { userDetailsActions, userDetailsLoad, userDetailsSuccess, userAccountsActions, userAccountsLoad, userAccountsSuccess, userAccountsFailure, usersActions, usersLoad } from './actions';
import { detailsLoadedSelector, accountsLoadedSelector, usersLoadedSelector, accountDetailsSelector } from './selectors';
/**
 * User details
 */

/**
 * User details request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadUserDetails = createRequestSaga(userDetailsActions, {
  loadedSelector: detailsLoadedSelector
});
/**
 * User details listener saga.
 * @return {Generator}
 */

export function userDetailsListener() {
  return _regeneratorRuntime.wrap(function userDetailsListener$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeLatest(userDetailsLoad, userDetailsSaga);

        case 2:
          _context.next = 4;
          return takeLatest(userDetailsSuccess, userDetailsSuccessSaga);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * User details saga. Fetches user details from the API and dispatches either
 * success or failure depending on the result.
 * @return {Generator}
 */

export function userDetailsSaga() {
  return _regeneratorRuntime.wrap(function userDetailsSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return put(api.get(userDetailsActions, '/me/details', null, null, true
          /*cacheBust*/
          ));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * User details saga. Fetches user details from the API and dispatches either
 * success or failure depending on the result.
 * @return {Generator}
 */

export function userDetailsSuccessSaga(_ref) {
  var userData;
  return _regeneratorRuntime.wrap(function userDetailsSuccessSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          userData = _ref.payload;
          _context3.next = 3;
          return call(setUserContext, userData);

        case 3:
          _context3.next = 5;
          return call(setFullStoryIdentity, userData);

        case 5:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * User accounts
 */

/**
 * User accounts request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadUserAccounts = createRequestSaga(userAccountsActions, {
  loadedSelector: accountsLoadedSelector
});
/**
 * User accounts listener saga.
 * @return {Generator}
 */

export function userAccountsListener() {
  return _regeneratorRuntime.wrap(function userAccountsListener$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(userAccountsLoad.getType(), userAccountsSaga);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * User accounts saga. Fetches user accounts from the API and dispatches either
 * success or failure depending on the result.
 * @return {Generator}
 */

export function userAccountsSaga() {
  return _regeneratorRuntime.wrap(function userAccountsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(api.get(userAccountsActions, '/me/accounts', null, null, true
          /*cacheBust*/
          ));

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * This saga syncs the active account to the account id in the url. This happens
 * when someone visits a url of an account that is not the current active account.
 * @param {Object} props - the loader's component props expected to contain the
 * computed match object that would contain the account id in the url.
 */

export function syncActiveAccountSaga(props) {
  var accountIdInUrl, activeAccountId, accountsPath, _yield$race, success, account, _accountsPath;

  return _regeneratorRuntime.wrap(function syncActiveAccountSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          accountIdInUrl = get(props, 'computedMatch.params.accountId');
          _context6.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context6.sent;

          if (!(!accountIdInUrl && !activeAccountId)) {
            _context6.next = 10;
            break;
          }

          _context6.next = 7;
          return select(accountsPathSelector);

        case 7:
          accountsPath = _context6.sent;
          _context6.next = 10;
          return put(push(accountsPath));

        case 10:
          if (!(accountIdInUrl !== activeAccountId && accountIdInUrl)) {
            _context6.next = 33;
            break;
          }

          _context6.next = 13;
          return put(userAccountsLoad());

        case 13:
          _context6.next = 15;
          return race({
            success: take(userAccountsSuccess),
            failure: take(userAccountsFailure)
          });

        case 15:
          _yield$race = _context6.sent;
          success = _yield$race.success;

          if (success) {
            _context6.next = 21;
            break;
          }

          _context6.next = 20;
          return put(logout());

        case 20:
          throw new AuthError();

        case 21:
          _context6.next = 23;
          return select(accountDetailsSelector, {
            accountId: accountIdInUrl
          });

        case 23:
          account = _context6.sent;

          if (account) {
            _context6.next = 31;
            break;
          }

          _context6.next = 27;
          return select(accountsPathSelector);

        case 27:
          _accountsPath = _context6.sent;
          _context6.next = 30;
          return put(push(_accountsPath));

        case 30:
          throw new AuthError('Account is not recognized, redirecting to accounts list...');

        case 31:
          _context6.next = 33;
          return put(setActiveAccount(account, {
            shouldRedirect: false
          }));

        case 33:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Users
 */

/**
 * Users request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadUsers = createRequestSaga(usersActions, {
  loadedSelector: usersLoadedSelector
});
/**
 * Users listener saga.
 * @return {Generator}
 */

export function usersListener() {
  return _regeneratorRuntime.wrap(function usersListener$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return takeLatest(usersLoad.getType(), usersSaga);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Users saga. Fetches users from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function usersSaga() {
  return _regeneratorRuntime.wrap(function usersSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return put(api.get(usersActions, '/me/users', null, null, true
          /*cacheBust*/
          ));

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}